const components = [];

components.forEach(component => component.init());
